<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-md-4.col-3.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t("ui.month") }}
          b-form-select(:options="monthOpt" v-model="selectedMonth" @change="getMonthlyRating" size="sm")
      .form-group.col-6.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getMonthlyRating()"
          variant="primary"
          size="sm"
        )

  .card-body
    .row(v-if="reviewList.length == 0")
      .col-md-12.mb-1
        h6
          span.alert.alert-danger {{ $t('message.no_rating_available') }}
    .row(v-else)
      .col-sm-12.col-md-12.col-lg-12
        .row
          .col-sm-12.col-md-6.col-lg-6(v-for="(item, index) in reviewList")
            .card.card-info
              .card-header
                span.font-weight-bold(:title="item.question") {{ item.question }}
                //- .float-right
                //-   span.float-right {{ $n(item.averageRating, 'currency') }} | {{ $n(item.total, 'integer') }} {{ $tc('ui.review', item.total)  }}
                //-   span.fas.fa-star.float-right.text-warning.mr-1(style="margin-top:2px;")
              .card-body
                .row.mb-3
                  .col-sm-3.col-md-3.col-lg-3
                    .animated.fadeIn.col-12(style="text-align:center;")
                      .text-value.row.text-center.m-0
                        span.fas.fa-star.text-warning.mt-2.mr-1
                        h3(:title="$n(item.averageRating, 'currency')") {{ $n(item.averageRating, 'currency') }}
                      .text-uppercase.text-muted(:title="$n(item.total, 'integer')") {{ $n(item.total, 'integer') }} 
                        span.small {{ $tc('ui.review', item.total)  }}
                  .col-sm-9.col-md-9.col-lg-9
                    .animated.fadeIn.col-12
                      bar-chart(:chartData="item.detail" :options="chartOptions" :styles="myStyles")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import BarChart from '@/barChart.js';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    BarChart
  },
  data: () => ({
    loading: false,
    monthOpt: [],
    summaryList: [],
    detailList: [],
    reviewList: [],
    selectedMonth: null,
    oprSortKey: "account_id",
    oprSortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    myStyles: {
      height: '200px',
      width: '100%',
      position: 'relative',
    },
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        enabled: true,
        mode: 'single',
        callbacks: {
          label: function(tooltipItem, data) {
            var txt = parseInt(tooltipItem.value) > 1 ? ' reviews' : ' review';
            return tooltipItem.value + txt;
          }
        }
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          categoryPercentage: 1.0,
          barPercentage: 0.9,
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: false
          }
        }],
        xAxes: [{
          ticks: {
            beginAtZero: true,
            display: false
          },
          gridLines: {
            display: false
          }
        }]
      },
    },
  }),
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  mounted: function() {
  },
  methods: {
    refresh() {
      // if(this.$store.getters.account[0]) {
      //   this.getMonthlyRating();
      // }
      this.getDateOpt();
      this.getMonthlyRating();
    },
    getDateOpt: function() {
      this.monthOpt = [];
      for(var i = 0; i > -3; i--) {
        this.monthOpt.push(this.$moment(new Date).add(i, 'month').format('YYYY-MM'));
      }

      this.selectedMonth = this.$moment(new Date).format('YYYY-MM');
    },
    getMonthlyRating: function() {
      let url = config.monthlyRatingUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        working_month: this.$moment(this.selectedMonth).startOf('month').format("YYYY-MM-DD"),
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(response.data.ds.summary.length > 0) {
                  this.summaryList = response.data.ds.summary;
                  this.detailList = response.data.ds.detail;

                  this.integrateReviewData();
                }
                else {
                  this.summaryList = [];
                  this.detailList = [];
                  this.reviewList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    integrateReviewData: function () {
      this.reviewList = [];
      this.summaryList.forEach(s => {
        var list = this.detailList.filter(d => { return d.survey_id == s.survey_id; });

        var ratingList = [];
        var rateCntList = [];
        list.forEach(l => {
          ratingList.push(l.rating);
          rateCntList.push(l.rate_count);
        });

        this.reviewList.push({
          question: s.question.trim(),
          averageRating: s.average_rating,
          total: s.total,
          detail: {
            labels: ratingList,
            datasets: [
              {
                backgroundColor: '#26C6DA',
                data: rateCntList
              },
            ]
          }
        })
      });
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>